import { useSelector } from "react-redux";

export const useIsSSR = () => useSelector(state => state.checkSSR.isSSR);
